import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { accountsEditService } from '../../edit/services/accountsEdit.service';

export function useAccountsDetail() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id') || '';

  const query = useQuery({
    queryKey: ['settings', 'accounts', 'detail', id],
    queryFn: () => accountsEditService.getAccount(id),
    enabled: !!id,
  });

  return {
    account: query.data,
    isLoading: query.isLoading,
  };
}
